import setFaq from './pages/faq';
import setTabs from './pages/abas';
//addImports

import setTopBar from "../components/topBar";

const Page = {
  init: function () {
    var _this = this;

    setTopBar();

    setFaq()
		setTabs();
		//calls

  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init()
})
